// apps/nos/client/src/services/recompute_api.ts
//
// Review-stage live recompute. POSTs the in-memory (unsaved) formulation to
// /viz/recompute and returns { previewId, viz }. The viz plugs into the
// existing aiVizOverride pipeline; the previewId is threaded into the
// Add-Ingredients endpoints. No DB writes.
import { serverURL } from "@/utils/serverURL";
import type { VizPayload } from "@/services/workbench_api";

export type RecomputeItem = {
  substanceKind: "compound" | "food";
  substanceId: number;
};

export type RecomputeResponse = {
  previewId: string;
  viz: VizPayload;
};

export async function fetchRecompute(
  args: {
    flavorId: string;
    formulaId: number;
    versionId: number;
    items: RecomputeItem[];
  },
  signal: AbortSignal,
): Promise<RecomputeResponse> {
  const res = await fetch(
    serverURL`/me/flavor/${args.flavorId}/formulas/${args.formulaId}/versions/${args.versionId}/viz/recompute`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: args.items }),
      signal,
    },
  );
  if (!res.ok) throw new Error(`viz/recompute failed: ${res.status}`);
  return (await res.json()) as RecomputeResponse;
}
